<template>
  <div id="app-main" class="data-list">
    <Result
      v-loading="searching"
      element-loading-text="正在搜索..."
      :resource-list="resourceList"
      :total="total"
      @pageNumChanged="handlePageNumChange"
      @pageSizeChanged="handlePageSizeChange"
    />
  </div>
</template>

<script>
// 接口
import { search } from '@/api/ResourceApi'
// 资源类型常量
import { typeName } from '@/constants/ResourceType'

import Result from './Result'

export default {
  name: 'Search',

  components: {
    Result
  },

  filters: {
    mapType(type) {
      return typeName[type]
    }
  },

  data() {
    return {
      searching: false,
      scope: this.$route.params.scope,
      content: this.$route.params.content,
      resourceList: [],
      pageNum: 1,
      pageSize: 15,
      total: 0
    }
  },

  beforeRouteUpdate(to, from, next) {
    this.scope = to.params.scope
    this.content = to.params.content
    this.pageNum = 1
    this.searchResource()
    next()
  },

  created() {
    this.searchResource()
  },

  methods: {
    searchResource() {
      const params = {
        scope: this.scope,
        content: this.content,
        page: this.pageNum,
        size: this.pageSize
      }
      this.searching = true
      this.searchTip = '正在搜索...'
      search(params)
        .then((resp) => {
          this.resourceList = resp.data.list
          this.total = resp.data.total
          this.searching = false
        })
        .catch(() => {
          this.searching = false
          this.searchTip = '搜索出错'
        })
    },

    handleView(resourceId) {
      this.$router.push({ name: 'ResourceInfo', params: { resId: resourceId }})
    },

    handlePageNumChange(pageNum) {
      this.pageNum = pageNum
      this.searchResource()
      this.$nextTick(() => {
        window.scrollTo({
          top: 135,
          behavior: 'smooth'
        })
      })
    },

    handlePageSizeChange(pageSize) {
      this.pageSize = pageSize
      this.searchResource()
    }
  }
}
</script>

<style scoped lang="scss">
#app-main {
  min-height: 800px;
  width: 1200px;
  margin: 0 auto;
}

.el-table {
  // 主体
  background-size: 100% 99%;
  padding: 15px;
  // 表头
  ::v-deep th {
    background-color: #fff;
    color: #222;
    font-size: 16px;
    font-family: Microsoft Yahei;
  }

  // 数据列表
  ::v-deep tr {
    background-color: rgba(255, 255, 255, 1);
    font-size: 14px;
  }

  ::v-deep .el-table__expand-column {
    visibility: hidden;
  }

  ::v-deep .el-table__cell {
    padding: 10px 0px;
    height: 25px;
  }

  ::v-deep .el-table__expanded-cell {
    height: 40px;
    padding: 5px 0px;
    padding-left: 10px;
    margin-top: 10px;
    margin-bottom: 10px;
    border-bottom: #986c33 solid 1px;
    padding: 10px 0 20px 10px;
  }

  ::v-deep em {
    color: red;
  }
}

.el-pagination {
  margin: 20px;
  .el-pager {
    .active {
      background-color: #8d7351;
    }
  }
}
</style>
